import { getOssToken } from '../security/tokenHelper';

const getOptions = (operation, data) => {
  let options = {
    method: operation,
    mode: 'cors',
    headers: {
      Authorization: getOssToken(),
    },
  };
  if (data) options = { ...options, body: data };
  return options;
};

const common = (url, body) => {
  return fetch(url, body)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw Error(`Request rejected with status ${response.status}`);
    })
    .then(data => {
      return Promise.resolve(data);
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

// todo:refactor
const download = url => {
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Authorization: getOssToken(),
    },
    responseType: 'blob',
  })
    .then(response => {
      if (response.ok) {
        return {
          name: response.headers.get('X-File-Name'),
          blob: response.blob(),
        };
      }
      throw Error(`Request rejected with status ${response.status}`);
    })
    .then(data => {
      return Promise.resolve(data);
    })
    .then(data => {
      data.blob.then(blob => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, data.name);
        } else {
          const link = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = link;
          a.download = data.name;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); // afterwards we remove the element again
        }
      });
    });
};

// todo:refactor
const postDownload = (url, data, isJson = true) => {
  let heads = {
    Authorization: getOssToken(),
  };
  if (isJson) heads = { ...heads, 'Content-Type': 'application/json' };
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: heads,
    responseType: 'blob',
    body: data,
  })
    .then(response => {
      if (response.ok) {
        return {
          name: response.headers.get('X-File-Name'),
          blob: response.blob(),
        };
      }
      throw Error(`Request rejected with status ${response.status}`);
    })
    .then(result => {
      return result.blob.then(blob => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, result.name);
        } else {
          const link = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = link;
          a.download = result.name;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); // afterwards we remove the element again
        }
      });
    });
};

const remote = {
  get: url => common(url, getOptions('GET')),
  post: (url, data) => common(url, getOptions('POST', data)),
  put: (url, data) => common(url, getOptions('PUT', data)),
  delete: url => common(url, getOptions('DELETE')),
  deleteMany: (url, data) => common(url, getOptions('DELETE', data)),
  download: url => download(url),
  postDownload: (url, data) => postDownload(url, data),
};

export default remote;
